angular.module('elfium').constant('REPORT_PHASE', {
	OTEVRENI_PRIPADU: 'Otevření případu',
	DOMLUV_PRVNI_SCHUZKA: 'Domluvený termín 1.sch',
	PROBEHLA_PRVNI_SCHUZKA: '1.schůzka proběhla',
	CHCI_NABIDKU: 'Chci nabídku',
	PRVNI_PREDANI_NABIDKY: '1.předání nabídky',
	ROZHODNUTI_O_NABIDCE: 'Rozhodnutí o nabídce',
	ZADANI_DO_PT: 'Zadání do PT'
}).constant('REPORT_PHASE_LABEL', {
	PROBEHLA_PRVNI_SCHUZKA: '1.schůzka'
}).constant('REPORT_REALIZATION', {
	PLAN: 'plan',
	ACTUAL: 'actual'
}).constant('REPORT_FIELD_TYPES', {
	BOOLEAN: ['isLocked']
});


// WEBPACK FOOTER //
// ./src/app/components/report/reportConstants.ts